import store from '../store'
import PGSHelper from '../helpers/PGSHelper.js';

export default class RealtimeWriter {
 

  constructor(data = null) {
    

  }
}